export const ADMIN_ROLES = ['OWNER', 'COOWNER'] as const;
export const TEAM_ROLES = ['OWNER', 'COOWNER', 'TEAM'] as const;

export const isAdmin = (role: string) => (ADMIN_ROLES as readonly string[]).includes(role);
export const isTeamMember = (role: string) => (TEAM_ROLES as readonly string[]).includes(role);
